import { addItemToCart } from "./QuickBuy";

export default (parentNode = document) => {
    const productCards = parentNode.querySelectorAll('.customProductCard');
    if (!productCards) return;

    initializeQuickBuyDialogs();

    document.addEventListener('click', async (e) => {
        const quickBuyButton = e.target.closest('span.customProductCard__buy');
        if (!quickBuyButton) return;

        e.preventDefault();

        const productCard = quickBuyButton.closest('.customProductCard');
        if (productCard.dataset.dialog_id) {
            const quickBuyDialog = document.querySelector(`#${productCard.dataset.dialog_id}`);
            if (!quickBuyDialog) return;
            quickBuyDialog.showModal();
            return;
        }

        quickBuyButton.classList.add('loading');
        await addItemToCart(quickBuyButton.dataset.product_id);
        quickBuyButton.classList.remove('loading');
    });
}

const initializeQuickBuy = (productCard) => {
    const quickBuyButton = productCard.querySelector('.customProductCard__buy');
    if (!quickBuyButton) return;

    quickBuyButton.addEventListener('click', async e => {
        e.preventDefault();

        if (productCard.dataset.dialog_id) {
            const quickBuyDialog = document.querySelector(`#${productCard.dataset.dialog_id}`);
            if (!quickBuyDialog) return;
            quickBuyDialog.showModal();
            return;
        }

        quickBuyButton.classList.add('loading');
        await addItemToCart(quickBuyButton.dataset.product_id);
        quickBuyButton.classList.remove('loading');
    });
}

const initializeQuickBuyDialogs = (parentNode = document) => {
    const quickBuyDialogs = parentNode.querySelectorAll('.quickBuyDialog');
    if (!quickBuyDialogs) return;

    quickBuyDialogs.forEach(quickBuyDialog => {
        const closeButton = quickBuyDialog.querySelector('span.close');
        closeButton.addEventListener('click', e => {
            e.preventDefault();
            quickBuyDialog.close();
        })

        quickBuyDialog.addEventListener('click', (event) => {
            let rect = event.target.getBoundingClientRect();
            if (rect.left > event.clientX ||
                rect.right < event.clientX ||
                rect.top > event.clientY ||
                rect.bottom < event.clientY
            ) {
                quickBuyDialog.close();
                document.body.classList.remove('body--no-scroll');
            }
        });

        const addToCartButton = quickBuyDialog.querySelector('.single_add_to_cart_button');
        const form = quickBuyDialog.querySelector('form');

        if(!form || !addToCartButton) return;

        jQuery(form).on('found_variation', (event, variation) => {
            const priceElement = addToCartButton.querySelector(':scope > span');
            if(!priceElement) return;
            priceElement.innerHTML = variation.price_html;
        })
        addToCartButton.addEventListener('click', async e => {
            e.preventDefault();
            const variationId = quickBuyDialog.querySelector('.variation_id').value;
            if (!variationId || variationId === '0') return;
            addToCartButton.classList.add('loading');
            await addItemToCart(variationId);
            addToCartButton.classList.remove('loading');
            quickBuyDialog.close();
        })
    })
}
